import {isRouteErrorResponse, Link, useRouteError} from 'react-router-dom';

export function RouteErrorPage() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : 500;
  const message = isRouteErrorResponse(error) ? error.statusText : error?.message || 'Something went wrong.';
  return <main className="route-error"><Link className="logo" to="/">yoori<span>.</span></Link><div><span>{status}</span><h1>We could not open this page</h1><p>{message}</p><div><button onClick={() => window.location.reload()}>Try again</button><Link to="/">Back to storefront</Link></div></div></main>;
}
